import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadershipMember } from '../leadership.component';

@Component({
  selector: 'app-leadership-assets',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss', '../leadership.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AssetsComponent {
  @Input() leadershipMembers: LeadershipMember[] = [];
  @Input() selectedDesign: 'podium' | 'grid' | 'timeline' | 'magazine' | 'minimal' = 'magazine';
  @Input() assetsPagination: any = {};
  @Output() loadMore = new EventEmitter<void>();

  get topThree(): LeadershipMember[] {
    return this.leadershipMembers.filter(m => m.rank <= 3).sort((a, b) => a.rank - b.rank);
  }

  loadMoreAssets(): void {
    this.loadMore.emit();
  }

  /**
   * Get the asset type icon path based on asset type
   */
  getAssetTypeIcon(assetType: string | undefined): string {
    if (!assetType) return '';
    
    const normalized = assetType.toLowerCase().trim();
    if (normalized === 'model') {
      return '/asset-ai-model.svg';
    } else if (normalized === 'dataset') {
      return '/asset-dataBank.svg';
    } else if (normalized === 'usecase') {
      return '/asset-use-case.svg';
    }
    return '';
  }
}

